import Offcanvas from "bootstrap/js/src/offcanvas";
import alert from "./Popup";
import {memoize} from "../util/utils";

const { __ } = wp.i18n;

export default class ProductPopup {
  constructor() {
    if(ProductPopup.exists) {
      return ProductPopup.instance;
    }
    ProductPopup.instance = this;
    ProductPopup.exists = true;

    this.popupEl = document.querySelector('#productPopup');

    if(!this.popupEl) {
      return;
    }

    this.productWrapper = this.popupEl.querySelector('.product-popup__product');
    this.popup = new Offcanvas(this.popupEl, {
      backdrop: true,
    });
    this.request = null;

    this.addHandlers();
  }

  addHandlers() {
    document.body.addEventListener('click', event => {
      if(event.target.classList.contains('btn-product-popup')) {
        event.preventDefault();
        event.stopPropagation();
        this.open( event.target.dataset.productId );
      }
    });

    $(document.body).on('added_to_cart', this.onAddedToCart.bind(this));
  }

  open(productId)
  {
    if(!productId) {
      alert.open({
        title: __('Oh no...', 'canopia'),
        type: 'warning',
        message: `<p>${__('Something went wrong', 'canopia')}</p>`,
        close: {
          text: __('Try again', 'canopia'),
        }
      });

      return;
    }

    this.reset();

    this.popup.show();
    this.renderProduct(productId);
  }

  reset()
  {
    this.popupEl.classList.add('loading');
    this.productWrapper.innerHTML = '';
    if(this.request) {
      this.request.abort();
    }
  }

  async renderProduct(productId)
  {

    try {
      let response = await this.getCachedProduct(productId);
      if(response.success) {
        this.productWrapper.innerHTML = response.data.html;
        this.popupEl.classList.remove('loading');
        this.initProductJs();
      }
    } catch (e) {

    }

  }

  async getProduct(id)
  {
    return $.ajax({
      url: palram.ajax_url,
      type: 'GET',
      data: {
        id,
        action: 'palram_get_product',
        secure: palram.nonces.get_product,
      },
    });
  }

  initProductJs()
  {
    let qty = this.productWrapper.querySelector('.product-popup_qty');

    if(qty) {
      $(qty).selectWoo({
        theme: 'qty',
        minimumResultsForSearch: Infinity,
        width: '100%',
        dropdownCssClass: 'popup-qty-dropdown',
      });
    }
  }

  getCachedProduct = memoize(this.getProduct);

  onAddedToCart(event, fragments, cart_hash, $button)
  {
    let currentButton = this.productWrapper.querySelector('.add-to-cart-btn');

    if($button.is($(currentButton))) {
     this.popup.hide();
    }
  }
}
